import React from 'react'
import { DndProvider } from 'react-dnd'
import { HTML5Backend } from 'react-dnd-html5-backend'
import DnDList from './dndList';

export default (props) => (
  <DndProvider backend={HTML5Backend}>
    <DnDList {...props} />
  </DndProvider>
);
